module.exports = __webpack_public_path__ + "fonts/Inter-SemiBoldItalic.woff2";